import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './QSearch.scss';
import { ComponentSync, LL_H_C, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
/**
 * @category Components
 */
export class QSearch extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.searchText = nextProps.filter ?? '';
        return state;
    }
    onClear = () => {
        this.setState({ searchText: '' }, () => this.props.onClear?.());
    };
    render() {
        const { onSearch, onClear, ...props } = this.props;
        return (_jsxs(LL_H_C, { className: "qsearch", children: [_jsx(ICONS.search.component, { className: 'qsearch-icon' }), this.state.searchText.length ?
                    _jsx("div", { className: 'clear-icon', onClick: () => {
                            this.props.onSearch('');
                            this.setState({ searchText: '' });
                        }, children: _jsx(ICONS.x.component, { onClick: this.onClear }) })
                    : null, _jsx(TS_Input, { ...props, id: `search-bar-${this.props.id}`, type: "text", value: this.state.searchText, placeholder: this.props.placeholder || 'Search', onChange: (searchText) => {
                        this.props.onSearch(searchText);
                        this.setState({ searchText });
                    }, onBlur: this.props.onBlur })] }));
    }
}
//# sourceMappingURL=QSearch.js.map